/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useMutation } from '@apollo/react-hooks';
import { ACCEPT_GDPR_FOR_ACCOUNT } from './mutations';
import messages from './intl-messages';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { AccountContext } from '../../../components/AccountContext';
import { useIntl } from 'react-intl';
import { growlErrors } from '../../../utils/NotificationUtil';

const SubmitDeclarationModal = ({ isVisible, onCancel }) => {
  const [firstAgreement, setFirstAgreement] = useState(false);
  const [secondAgreement, setSecondAgreement] = useState(false);
  const [thirdAgreement, setThirdAgreement] = useState(false);

  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const { formatMessage } = useIntl();

  const [updateGdpr] = useMutation(ACCEPT_GDPR_FOR_ACCOUNT, { refetchQueries: ['getAccount', 'getUserAgreement'] });

  return (
    <Dialog
      header={formatMessage(messages.gdprAgreementTitle)}
      visible={isVisible}
      style={{ width: '50vw', padding: '4px' }}
      modal
      onHide={onCancel}
    >
      <div className="p-grid">
        <div className="p-col-1 p-col-align-center" style={{ textAlign: 'center' }}>
          <Checkbox onChange={(e) => setFirstAgreement(e.checked)} checked={firstAgreement} />
        </div>
        <p className="p-col-11">{formatMessage(messages.gdprAgreementPartOne)}</p>

        <div className="p-col-1 p-col-align-center" style={{ textAlign: 'center' }}>
          <Checkbox onChange={(e) => setSecondAgreement(e.checked)} checked={secondAgreement} />
        </div>
        <p className="p-col-11">{formatMessage(messages.gdprAgreementPartTwo)}</p>

        <div className="p-col-1 p-col-align-center" style={{ textAlign: 'center' }}>
          <Checkbox onChange={(e) => setThirdAgreement(e.checked)} checked={thirdAgreement} />
        </div>
        <p className="p-col-11">{formatMessage(messages.gdprAgreementPartThree)}</p>

        <div style={{ textAlign: ' center', width: '100%' }}>
          <Button
            label={formatMessage(messages.gdprSubmitButtonLabel)}
            disabled={!firstAgreement || !secondAgreement || !thirdAgreement}
            onClick={() => {
              updateGdpr({ variables: { id: currentAccount } })
                .then(() => {
                  growl.show({
                    severity: 'success',
                    summary: formatMessage(messages.growlGdprAgreementSummary),
                    detail: formatMessage(messages.growlGdprAgreementSuccess),
                    sticky: false,
                  });
                })
                .catch((errors) => {
                  growlErrors(growl, errors);
                });
            }}
          />
        </div>
      </div>
    </Dialog>
  );
};

SubmitDeclarationModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default SubmitDeclarationModal;
